// extracted by mini-css-extract-plugin
module.exports = {"DeleteButtonArea":"CompanyDetailModal_DeleteButtonArea__aHoaz"};